import axios from "axios";
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { functionBaseUrl } from "../../common/firebase";
import { useCustomTokenAuth } from "../../hooks/useCustomTokenAuth";

const useDevices = () => {
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);

  const studioAccountId = queryParams.get("studioAccountId");
  // const deviceId = queryParams.get("deviceId");
  // const deviceName = queryParams.get("deviceName");
  // const isCoachQueryParams = queryParams.get("isCoach");
  // const isCoach = isCoachQueryParams === "true";

  const { signInWithCustomToken } = useCustomTokenAuth();

  const [devices, setDevices] = React.useState(null);
  const [isCoachShowSuccess, setIsCoachShowSuccess] = React.useState(false);
  const [loading, setLoading] = React.useState(true);

  const fetchDevices = async () => {
    try {
      setLoading(true);
      const response = await axios(
        functionBaseUrl + "/api/partner/v1/getDevices",
        {
          method: "POST",
          data: {
            studioAccountId,
          },
          headers: {
            authorization:
              "elB55CL3E44Kbr/LFrvIGld=LoUn9zyfuNvkbAjsmXbbLt!wp?VbBCUrAM/tjpU!Gxml-Y=pHiih?!PZSFqL35jAA-J?Vwij3=RWeaFdg==CjR/TVD9Yv!eAcCBS/4db",
          },
        }
      );

      setDevices(response?.data?.devices || []);
      setLoading(false);
    } catch (err) {
      console.error("Error fetchDevices:", err);
    }
  };

  const removeDevice = async ({ deviceId }) => {
    try {
      const response = await axios(
        functionBaseUrl + "/api/partner/v1/removeDevice",
        {
          method: "POST",
          data: {
            studioAccountId,
            deviceId,
          },
          headers: {
            authorization:
              "elB55CL3E44Kbr/LFrvIGld=LoUn9zyfuNvkbAjsmXbbLt!wp?VbBCUrAM/tjpU!Gxml-Y=pHiih?!PZSFqL35jAA-J?Vwij3=RWeaFdg==CjR/TVD9Yv!eAcCBS/4db",
          },
        }
      );
      if (response?.data?.success) {
        toast.success("Device removed successfully");
      } else {
        toast.error("Failed to remove device: " + response.data.message);
      }

      await fetchDevices(); // Refresh the device list after adding
    } catch (err) {
      console.error("Error removing device:", err);
    }
  };

  // const addDevice = async () => {
  //   try {
  //     const response = await axios(
  //       functionBaseUrl + "/api/partner/v1/addDevice",
  //       {
  //         method: "POST",
  //         data: {
  //           studioAccountId,
  //           device: {
  //             deviceId: deviceId,
  //             deviceName: deviceName,
  //             platform: 3,
  //           },
  //         },
  //         headers: {
  //           authorization:
  //             "elB55CL3E44Kbr/LFrvIGld=LoUn9zyfuNvkbAjsmXbbLt!wp?VbBCUrAM/tjpU!Gxml-Y=pHiih?!PZSFqL35jAA-J?Vwij3=RWeaFdg==CjR/TVD9Yv!eAcCBS/4db",
  //         },
  //       }
  //     );

  //     if (response?.data?.success) {
  //       toast.success("Device added successfully");
  //       setIsCoachShowSuccess(true);
  //     } else {
  //       toast.error("Failed to add device: " + response.data.message);
  //     }
  //     await fetchDevices(); // Refresh the device list after adding
  //   } catch (err) {
  //     console.error("Error removing device:", err);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  useEffect(() => {
    fetchDevices(studioAccountId);
  }, [studioAccountId]);

  // useEffect(() => {
  //   if ((studioAccountId, deviceId, deviceName)) {
  //     addDevice();
  //   }
  // }, [studioAccountId, deviceId, deviceName]);

  return {
    loading,
    // isCoachShowSuccess,
    // isCoach,
    devices,
    // addDevice,
    removeDevice,
  };
};

export default useDevices;
